import { render } from "./Sidebar.vue?vue&type=template&id=99dc46fa&ts=true"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99dc46fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99dc46fa', __exports__)) {
    api.reload('99dc46fa', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=99dc46fa&ts=true", () => {
    api.rerender('99dc46fa', render)
  })

}


export default __exports__